module.exports = __webpack_public_path__ + "c303a70a2a8766198c17c7dca4c8a28a.png";


//////////////////
// WEBPACK FOOTER
// ./res/images/backgrounds/es/stingray_business.png
// module id = 862
// module chunks = 0